module.exports = __webpack_public_path__ + "static/media/celular-gmad-pay.88fedfdf.png";